export default __webpack_public_path__ + "18613265a37a7cd04e0d23321336b1a9.png";